import { ApolloClient, InMemoryCache, createHttpLink, NormalizedCacheObject } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import AuthorizationHeader from '../../lib/authorization-header';

let apolloClient: ApolloClient<NormalizedCacheObject>;
let Authorization = 'Bearer *';

async function getClient({ forceRefresh = false, fetch = window.fetch } = {}): Promise<ApolloClient<
  NormalizedCacheObject
> | null> {
  try {
    const authHeaders = await AuthorizationHeader.getCognitoHeader();
    let authTokenChanged = false;
    if (
      authHeaders &&
      authHeaders.headers &&
      authHeaders.headers.Authorization &&
      authHeaders.headers.Authorization !== Authorization
    ) {
      authTokenChanged = true;
      Authorization = authHeaders.headers.Authorization;
    }
    if (!apolloClient || authTokenChanged || forceRefresh) {
      const httpLink = createHttpLink({
        uri: process.env.REACT_APP_CLIENT_GRAPHQL_API,
      });

      const authLink = setContext((_, { headers }) => ({
        headers: {
          ...headers,
          authorization: Authorization,
        },
        fetch,
      }));

      const opts = {
        link: authLink.concat(httpLink),
        cache: new InMemoryCache(),
      };
      apolloClient = new ApolloClient(opts);
    }

    return apolloClient;
  } catch (err) {
    console.error(err);
    return null;
  }
}

export default getClient;
